import { Controller } from 'react-hook-form'
import classNames from 'classnames'
import { DatePicker } from 'rsuite'
import moment from 'moment'
import { LOCAL_DAY_TH } from '../../constants/date'
import { dateMonst2 } from '../../utils/dataUtil'

export default function EditDateCell({
  id,
  rowData,
  dataKey,
  register,
  control,
  errors,
  startDate,
  endDate,
  defaultDate,
  isEdit,
  onChangeCell = () => {},
  rules,
  ...props
}) {
  const editing = rowData.status === 'EDIT' || isEdit
  const _id = id || rowData.id

  return (
    <>
      <span {...props} className={editing ? 'table-content-editing' : ''}>
        {editing ? (
          <>
            {startDate || endDate ? (
              <Controller
                name={id || rowData.id}
                control={control}
                defaultValue={
                  defaultDate ||
                  (rowData[dataKey]
                    ? moment(rowData[dataKey], 'DD/MM/YYYY').toDate()
                    : moment().startOf('day').toDate())
                }
                rules={rules || { required: 'กรุณากรอกกำหนดส่งผลงาน' }}
                render={(props) => {
                  return (
                    <DatePicker
                      className={classNames(errors[_id] && 'is-error')}
                      format="DD/MM/YYYY"
                      locale={LOCAL_DAY_TH}
                      block
                      oneTap
                      placement="auto"
                      value={props.value}
                      onChange={(value) => {
                        props.onChange(value)
                        onChangeCell(value)
                      }}
                      disabledDate={(date) => dateMonst2(date, startDate, endDate)}
                    />
                  )
                }}
              />
            ) : (
              <Controller
                name={id || rowData.id}
                control={control}
                defaultValue={
                  defaultDate ||
                  (rowData[dataKey]
                    ? moment(rowData[dataKey], 'DD/MM/YYYY').toDate()
                    : moment().startOf('day').toDate())
                }
                rules={rules || { required: 'กรุณากรอกกำหนดส่งผลงาน' }}
                render={(props) => {
                  return (
                    <DatePicker
                      className={classNames(errors[_id] && 'is-error')}
                      format="DD/MM/YYYY"
                      locale={LOCAL_DAY_TH}
                      block
                      oneTap
                      placement="auto"
                      value={props.value}
                      onChange={(value) => {
                        props.onChange(value)
                        onChangeCell(value)
                      }}
                    />
                  )
                }}
              />
            )}
          </>
        ) : (
          <span>{rowData[dataKey]}</span>
        )}
      </span>
    </>
  )
}
